import objectPath from 'object-path'
import cloneDeep from 'clone-deep'
import {
  getCurrentUi,
  updateUiSchema,
} from 'designer/component/action/Data'

const getRuleShowHideListTarget = (action = {}, target = '') => {
  return (
    target ||
    action.target ||
    action.targetKey ||
    action.key ||
    action.valueKey ||
    action.targetName ||
    action.targetOptionValue ||
    action.formDataKey ||
    ''
  )
}

const getRuleShowHideListCompareKey = (action = {}, status = {}) => {
  if (action.compareKey) return action.compareKey
  if (action.sourceKey) return action.sourceKey
  if (action.copyFrom?.key) return action.copyFrom.key
  if (action.compareFrom?.key) return action.compareFrom.key
  if (status.uiKey) return status.uiKey

  let ruleUiKeys = Array.isArray(status.ruleUiKeys)
    ? status.ruleUiKeys
    : [status.ruleUiKeys]

  return ruleUiKeys.filter((key) => key)[0] || ''
}

const getRuleShowHideListCompareData = (
  formData = {},
  compareKey = '',
  compareUi = {},
  status = {},
) => {
  let ruleUiKeys = Array.isArray(status.ruleUiKeys)
    ? status.ruleUiKeys
    : [status.ruleUiKeys]

  if (
    status.valueChange !== undefined &&
    (!compareKey || ruleUiKeys.includes(compareKey))
  ) {
    return status.valueChange
  }

  return (
    objectPath.get(formData, compareKey) ??
    objectPath.get(formData, compareUi.name)
  )
}

const getRuleShowHideListCompareList = (compareData, compareUi = {}) => {
  let compareList
  if (compareUi.valueType === 'string' && typeof compareData === 'string') {
    compareList = compareData.split(compareUi.valueJoin || '') || []
  } else {
    compareList = compareData || []
  }

  if (!Array.isArray(compareList)) {
    compareList = [compareList]
  }

  return compareList
}

const setRuleShowHideListAction = (
  designContext = {},
  targetKey = '',
) => {
  let { elementAction = {}, setElementAction } = designContext

  objectPath.set(elementAction, ['isShowHideList', targetKey], true)
  if (setElementAction) setElementAction(elementAction)
}

const setRuleShowHideListUiChanged = (
  designContext = {},
  targetKey = '',
) => {
  let { isUiChanged = {}, setIsUiChanged } = designContext

  objectPath.set(isUiChanged, targetKey, { isRender: true })
  if (setIsUiChanged) setIsUiChanged(isUiChanged)
}

export const onRuleShowHideList = (
  designContext = {},
  action = {},
  status = {},
  target = '',
) => {
  let { jsonForm = {} } = designContext
  let formData = status.formData || jsonForm.formData || {}
  let targetKey = getRuleShowHideListTarget(action, target)
  let compareKey = getRuleShowHideListCompareKey(action, status)
  if (!targetKey || !compareKey) return undefined

  let compareUi = getCurrentUi(compareKey, jsonForm.schema, jsonForm.uischema)
  let actionUi = getCurrentUi(targetKey, jsonForm.schema, jsonForm.uischema)
  let actionElements = cloneDeep(actionUi.elements || [])
  let compareData = getRuleShowHideListCompareData(
    formData,
    compareKey,
    compareUi,
    status,
  )

  if (compareUi.isMulti) {
    let compareList = getRuleShowHideListCompareList(compareData, compareUi)

    actionElements.forEach((element) => {
      let foundOptionId = compareList.find(
        (value) => value === element.optionId,
      )
      let subElements = element.elements || []

      subElements.forEach((subElement) => {
        subElement.isShowUi = foundOptionId ? true : false
      })
      element.isShowUi = foundOptionId ? true : false
      element.elements = subElements
      objectPath.set(
        formData,
        `@${element.name}.@${compareUi.name}`,
        foundOptionId,
      )
    })
  }

  updateUiSchema(targetKey, 'elements', actionElements, jsonForm)
  setRuleShowHideListAction(designContext, targetKey)
  setRuleShowHideListUiChanged(designContext, targetKey)

  return {
    key: targetKey,
    compareKey,
  }
}
